import { createSignal, onCleanup } from "solid-js";

type UsePollingOptions = {
  /** 轮询间隔 */
  interval: number;
  /** 轮询时长 */
  duration?: number;
  /** 轮询回调 */
  callback: () => void | Promise<void>;
};

export const usePolling = (props: UsePollingOptions) => {
  const [running, setRunning] = createSignal(false);
  const [finished, setFinished] = createSignal(false);
  let timer: ReturnType<typeof setTimeout> | null = null;
  let timeout: ReturnType<typeof setTimeout> | null = null;
  let isStopped = false; // 防止重复停止

  const start = () => {
    if (running()) return;
    setRunning(true);
    setFinished(false);
    isStopped = false;

    const tick = () => {
      if (!running()) return;
      props.callback();
      timer = setTimeout(tick, props.interval);
    };

    tick();

    if (props.duration) {
      timeout = setTimeout(() => {
        stop();
      }, props.duration);
    }
  };

  const pause = () => {
    if (!running()) return;
    setRunning(false);
    if (timer !== null) clearTimeout(timer);
    timer = null;
  };

  const stop = () => {
    if (isStopped) return; // 防止重复停止
    isStopped = true;

    pause();
    setFinished(true);
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  // 清理所有定时器，但不设置 finished 状态
  onCleanup(() => {
    isStopped = true;
    if (timer !== null) {
      clearTimeout(timer);
      timer = null;
    }
    if (timeout !== null) {
      clearTimeout(timeout);
      timeout = null;
    }
    setRunning(false);
  });

  return { start, pause, stop, running, finished };
};
